module.exports = __webpack_public_path__ + "static/img/two.3091166.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newVcard/two.png
// module id = XSUQ
// module chunks = 1